export enum ItemEnum {
  ADD = "ADD",
  UPDATE = "UPDATE",
  DOCKET = "DOCKET",
  GROUP = "GROUP",
  ESTIMATION = "ESTIMATION",
  XERO = "XERO",
  DOCKET_ITEM = "DOCKET_ITEM",
  DOCKET_ITEMS = "DOCKET_ITEMS",
  ESTIMATION_ITEM = "ESTIMATION_ITEM",
  ESTIMATION_ITEMS = "ESTIMATION_ITEMS",
  DEACTIVATED = "DEACTIVATED",
}

export enum ITEM_STATUS {
  ACTIVE = "ACTIVE",
  DEACTIVATED = "DEACTIVATED",
}

export const ItemsMessage = {
  ITEMS_TABLE_UPDATED: "Items table updated",
  GROUP_TABLE_UPDATED: "Group table updated",
  XERO_TABLE_UPDATED: "Xero table updated",

  DOCKET_CREATED: "Docket Item created successfully",
  DOCKET_UPDATED: "Docket Item's updated successfully",
  DOCKET_DELETED: "Docket Item deleted successfully",
  DOCKET_STATUS_UPDATED: "Docket Item Status Updated Successfully",

  ESTIMATION_CREATED: "Estimation Item created successfully",
  ESTIMATION_UPDATED: "Estimation Item updated successfully",
  ESTIMATION_DELETED: "Estimation Item deleted successfully",

  GROUP_CREATED: "Group created successfully",
  GROUP_UPDATED: "Group updated successfully",
  GROUP_DELETED: "Group deleted successfully",

  ITEM_SYNCED_WITH_XERO_SUCCESS: "Item synced with Xero successfully",
  ITEMS_SYNC_SUCCESS: "Items synced successfully",

  ITEM_ACTIVATED_SUCCESS: "Item activated successfully",
  ITEM_DEACTIVATED_SUCCESS: "Item deactivated successfully",
};

export const EmptyItemsTableMessage = {
  GROUP: {
    SUBTITLE: "Add new Group to get started",
    BTN_LABEL: "Add New Group",
    DELETE_WARNING:
      "If you delete this you cannot restore this group and all the items associated with this group will be revoked.",
  },
  DOCKET: {
    SUBTITLE: "Add a new Item to the list.",
    BTN_LABEL: "Add Items",
  },
  XERO: {
    SUBTITLE: "Add new Xero items to get started",
  },
};

export const ItemConstant = {
  HEADERS: {
    INDEX: "ITEMS",
    DOCKET_ITEMS: "DOCKET ITEMS",
    ESTIMATE_ITEMS: "ESTIMATION ITEMS",
    DEACTIVATED_ITEMS: "DEACTIVATED ITEMS",
  },
  UTILS: {
    SYNC: "SYNC",
    XERO_ITEMS: "XERO ITEMS",
    SYNCED: "SYNCED",
    NOT_SYNCED: "NOT SYNCED",
    DELETE_CONFIRMATION_DESC: "If you delete this you cannot restore this item",
    SYNC_WITH_XERO_ITEM: "Sync with Xero Item",
    GROUP: "Group",
    ADD_NEW_GROUP: "Add New Group",
    UPDATE_GROUP: "Update Group",
    ADD_MULTIPLE_PRICE: "Add Multiple Price",
  },
  BTN_LABEL: {
    ADD_DOCKET_ITEM: "Add Docket Item",
    ADD_ESTIMATE_ITEM: "Add Estimation Item",
  },
};
